import { ErrorHandler, Injectable } from '@angular/core';
import { Message, Severity } from '../model/message';

import { HttpErrorResponse } from '@angular/common/http';
import { NotifierService } from '../services/notifier.service';
import { environment } from '@environments/environment';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorsHandler implements ErrorHandler {

  constructor(private notifierService: NotifierService) { }

  handleError(error: Error | HttpErrorResponse) {

    if (!navigator.onLine) {
      console.warn('Handle offline error', error);
      const err = new Message(environment.messages.noConnection, Severity.ERROR);
      this.notifierService.show(err);
    } else {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 404) {
          this.notifierService.logError(error);
        } else {
          console.warn('Generic Error', error);
          this.notifierService.show(this.formatError(error, Severity.ERROR));
        }
      } else {
        console.warn('Handle Client Error', error);
        this.notifierService.show(this.formatError(error));
      }
    }
  }

  formatError( error: Error | HttpErrorResponse | any, severity?: Severity) {
    console.warn('format error 400', error);
    let code;
    if (error.code === 'auth/network-request-failed') {
      return new Message(environment.messages.noConnection, (severity) ? severity : Severity.ERROR);
    }

    if (error.status || error.error) {
      code = (error.status) ? error.status : (error.error.status) ? error.error.status : '';
    }

    const message = this.formatErrorMessages(error);
    return new Message(message, (severity) ? severity : Severity.ERROR, (code) ? code : '');
  }

  formatMessage(message: string, severity?: Severity) {
    return new Message(message, (severity) ? severity : Severity.SUCCESS, '200');
  }

  private formatErrorMessages(error: Error | HttpErrorResponse | any) {
    let txt = error.error && error.error.message || error.message;

    if (error.status === 400 || error.status === 200) {
      txt = `[${error.status}] Errore richiesta non andata a buon fine.`;
    }

    if (error.status === 0) {
      txt = `[${error.status}] Errore sconosciuto richiesta non andata a buon fine.`;
    }

    return txt;
  }
}
